import React, { useContext } from "react";
import { rates } from "../../rbac-consts";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { default as AdminRatesDetailsContainer } from "./admin/RatesDetailsContainer";
import { default as ClientRatesDetailsContainer } from "./client/details/RatesDetailsContainer";

const RatesDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={rates.ADMIN}
        yes={() => (
          <AdminRatesDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={rates.USER}
        yes={() => (
          <ClientRatesDetailsContainer match={match}/>
        )}
      />
    </>
  );
};

export default RatesDetailsWrapper;